import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.webp";
import menuItems from "../data/menuItems";

const Header = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openSubMenuMobile, setOpenSubMenuMobile] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);
  const [openSubMenuDesktop, setOpenSubMenuDesktop] = useState(null);

  return (
    <header className="w-full fixed top-0 left-0 z-50 shadow-md bg-white">
      {/* Top Bar */}
      <div className="max-w-7xl mx-auto flex justify-between items-center px-6 py-3 md:py-3">
        {/* Logo */}
        <Link to="/">
          <img src={logo} alt="Logo" className="h-20 md:h-20" />
        </Link>

        {/* Toll-Free */}
        <a
          href="tel:18008918455"
          className="hidden md:inline-block bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md font-semibold transition"
        >
          Toll Free - 1800 8918 455
        </a>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-blue-900 text-2xl focus:outline-none"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          ☰
        </button>
      </div>

      {/* Desktop Menu */}
      <nav className="hidden md:flex justify-center space-x-8 max-w-7xl mx-auto px-6 py-3">
        {menuItems.map((item) => (
          <div
            key={item.label}
            className="relative"
            onMouseEnter={() => item.dropdown && setOpenMenu(item.label)}
          >
            {item.link ? (
              <Link
                to={item.link}
                className={`pb-1 transition-colors duration-200 font-medium ${
                  location.pathname === item.link
                    ? "text-green-600 border-b-2 border-green-600"
                    : "text-blue-900 hover:text-green-600"
                }`}
              >
                {item.label}
              </Link>
            ) : (
              <button
                type="button"
                onClick={() => setOpenSubMenuDesktop(null)}
                className="pb-1 text-blue-900 hover:text-green-600 cursor-pointer font-medium"
              >
                {item.label}
              </button>
            )}

            {/* Dropdown */}
            {item.dropdown && openMenu === item.label && (
              <div className="absolute left-0 mt-2 bg-white shadow-lg rounded-md w-48">
                {item.dropdown.map((opt) => (
                  <div key={opt.label} className="relative">
                    {opt.submenu ? (
                      <>
                        <button
                          type="button"
                          onClick={() =>
                            setOpenSubMenuDesktop(
                              openSubMenuDesktop === opt.label ? null : opt.label
                            )
                          }
                          className="flex justify-between items-center w-full px-4 py-2 text-left text-blue-900 hover:bg-green-50"
                        >
                          {opt.label} <span className="ml-2">›</span>
                        </button>
                        {openSubMenuDesktop === opt.label && (
                          <div className="absolute left-full top-0 ml-1 bg-white shadow-lg rounded-md w-48">
                            {opt.submenu.map((sub) => (
                              <Link
                                key={sub.label}
                                to={sub.link}
                                className={`block px-4 py-2 text-sm text-blue-900 hover:bg-green-100 ${
                                  location.pathname === sub.link
                                    ? "text-green-600 font-semibold"
                                    : ""
                                }`}
                                onClick={() => {
                                  setOpenMenu(null);
                                  setOpenSubMenuDesktop(null);
                                }}
                              >
                                {sub.label}
                              </Link>
                            ))}
                          </div>
                        )}
                      </>
                    ) : (
                      <Link
                        to={opt.link}
                        className="block px-4 py-2 text-blue-900 hover:bg-green-100"
                        onClick={() => setOpenMenu(null)}
                      >
                        {opt.label}
                      </Link>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white shadow-md">
          {menuItems.map((item) => (
            <div key={item.label} className="px-6 py-3">
              {item.dropdown ? (
                <>
                  <button
                    className="w-full text-left text-blue-900 font-medium flex justify-between items-center"
                    onClick={() =>
                      setOpenSubMenuMobile(
                        openSubMenuMobile === item.label ? null : item.label
                      )
                    }
                  >
                    {item.label}
                    <span>{openSubMenuMobile === item.label ? "▲" : "▼"}</span>
                  </button>

                  {openSubMenuMobile === item.label && (
                    <div className="pl-4 mt-2 space-y-1">
                      {item.dropdown.map((opt) =>
                        opt.submenu ? (
                          <div key={opt.label}>
                            <p className="font-medium text-blue-900">{opt.label}</p>
                            <div className="pl-4 space-y-1">
                              {opt.submenu.map((sub) => (
                                <Link
                                  key={sub.label}
                                  to={sub.link}
                                  className="block text-sm text-gray-700 hover:text-green-600 py-1"
                                  onClick={() => setMobileOpen(false)}
                                >
                                  {sub.label}
                                </Link>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <Link
                            key={opt.label}
                            to={opt.link || "#"}
                            className="block text-sm text-gray-700 hover:text-green-600 py-1"
                            onClick={() => setMobileOpen(false)}
                          >
                            {opt.label}
                          </Link>
                        )
                      )}
                    </div>
                  )}
                </>
              ) : (
                <Link
                  to={item.link}
                  className="block w-full text-blue-900 font-medium"
                  onClick={() => setMobileOpen(false)}
                >
                  {item.label}
                </Link>
              )}
            </div>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
